import type { ColumnDef } from "@tanstack/table-core";
import { TextWithOverflowTooltip } from "src/components/TextWithOverflowTooltip";
import { formatUuid } from "src/services/id";
import type { GlossaryFn } from "src/types/glossary";
import { ColumnId } from "./constants";

type SchoolIdColumnDefConfig = {
  glossary: GlossaryFn;
};

type Row = {
  school: { id: uuid; referenceId?: string | null } | null;
};
export function buildSchoolIdColumnDef<T extends Row>({
  glossary,
}: SchoolIdColumnDefConfig): ColumnDef<T> {
  return {
    id: ColumnId.SchoolId,
    header: glossary`School ID`,

    cell: (props) => (
      <TextWithOverflowTooltip
        content={formatUuid(props.row.original.school?.id ?? "")}
        maxWidth="9em"
      />
    ),
  };
}
export function buildSchoolReferenceIdColumnDef<T extends Row>({
  glossary,
}: SchoolIdColumnDefConfig): ColumnDef<T> {
  return {
    id: ColumnId.SchoolReferenceId,
    header: glossary`School Reference ID`,
    accessorFn: (row) => row.school?.referenceId ?? null,
  };
}
